// client/src/routes/admin/accounts.tsx — SCR-ADM-004 „Conturi" · ADM-001 (04 §8.19).
//
// The route owns the URL and nothing else; the screen is the feature's. There is no
// `validateSearch` here, unlike SCR-AUD-001: the filters on this screen are local state, not
// URL state, because the platform area has no deep links to share and no screen to come back
// to — see the note in `AccountsScreen`.
//
// No `RequirePermission` wrapper either. `/admin`'s layout route already gates the whole area
// on `Platform.Admin` (D-1640), and a second check here could only ever disagree with it.

import { createFileRoute } from '@tanstack/react-router';

import { AccountsScreen } from '@/features/platform/AccountsScreen';

export const Route = createFileRoute('/admin/accounts')({
  component: AccountsScreen,
});
